// extracted by mini-css-extract-plugin
module.exports = {"headingWrap":"account-balance_headingWrap__qL9Vw","balanceWrap":"account-balance_balanceWrap__n926b","balance":"account-balance_balance__kH1Yo"};